import { reportMainModule } from "@/store/reports/reportMainModule";
import { reportStudyModule } from "@/store/reports/reportStudyModule";
import { reportPreparationModule } from "@/store/reports/reportPreparationModule";
import { reportShiftsModule } from "@/store/schedule/reportShiftsModule";
import { reportPlanModule } from "@/store/sales/reportPlanModule";
import { reportPlanTatarModule } from "@/store/sales/reportPlanTatarModule";
import { reportEditPlanModule } from "@/store/sales/reportEditPlanModule";
import { reportDDSModule } from "@/store/finance/reportDDSModule";
import { reportFoodCostModule } from "@/store/finance/reportFoodCostModule";
import { motivationModule } from "@/store/reports/motivationModule";
import { reportProductOrdersModule } from "@/store/reports/reportProductOrdersModule";
import { reportByProductsModule } from "@/store/reports/reportByProductsModule";
import { reportProductionAnalitycsModule } from "@/store/reports/reportProductionAnalitycsModule";
import { reportFoodWorkersModule } from "@/store/reports/reportFoodWorkersModule";
import { reportWriteOffModule } from "@/store/reports/reportWriteOffModule";
import { reportByDaysModule } from "@/store/reports/reportByDaysModule";
import { reportReservation } from "@/store/reports/reportReservationModule";
import { reportByHoursModule } from "@/store/reports/reportByHoursModule";
import { reportStopListsModule } from "@/store/reports/reportStopListsModule";
import { reportTableUpdatesModule } from "@/store/reports/reportTableUpdatesModule";
import { reportGameProgressModule } from "@/store/reports/reportGameProgressModule";
import { reportFillingAverageCheckModule } from "@/store/reports/reportFillingAverageCheckModule";
import { reportNonIntegratedOrdersModule } from "@/store/reports/reportNonIntegratedOrdersModule";
import { reportOrderHelpersModule } from "@/store/reports/reportOrderHelpersModule";
import { reportGuestWaitTimeModule } from "@/store/reports/reportGuestWaitTimeModule";
import { reportCouncilModule } from "@/store/reports/reportCouncilModule";
import { reportCookingModule } from "@/store/reports/reportCookingModule";
import { reportDetailedChecksModule } from "@/store/reports/reportDetailedChecksModule";
import { reportWaiterFfficiencyModule } from "@/store/reports/reportWaiterFfficiencyModule";
import { reportTopProductsModule } from "@/store/reports/reportTopProductsModule";
import { reportVacanciesModule } from "@/store/reports/reportVacanciesModule";
import { reportSummaryInvoicesModule } from "@/store/reports/reportSummaryInvoicesModule";
import { reportWorkloadModule } from "@/store/reports/reportWorkloadModule";
import { reportInvestmentsModule } from "@/store/reports/reportInvestmentsModule";
import { reportAverageTimeOfFrontsModule } from "@/store/reports/reportAverageTimeOfFrontsModule";
import { reportTatarModule } from "@/store/reports/reportTatarModule";
import { reportPlanSalesModule } from "@/store/reports/reportPlanSalesModule";
import { reportCounteragentsModule } from "@/store/reports/reportCounteragentsModule";
import { reportSprintModule } from "@/store/reports/reportSprintModule";
import { reportWollzyModule } from "@/store/reports/reportWollzyModule";
import { motivationTatarModule } from "@/store/reports/motivationTatarModule";
import { reportBalanceSheetModule } from "@/store/reports/reportBalanceSheetModule";
import { reportMotivationCheeseriaModule } from "@/store/reports/reportMotivationCheeseriaModule";
import { reportMotivationPayrollModule } from "@/store/reports/reportMotivationPayrollModule";
import { reportSalesAreaModule } from "@/store/reports/reportSalesAreaModule";

export const reportsModules = {
    reportMain: reportMainModule,
    reportStudy: reportStudyModule,
    reportPreparation: reportPreparationModule,
    reportShifts: reportShiftsModule,
    reportPlan: reportPlanModule,
    reportPlanTatar: reportPlanTatarModule,
    reportEditPlan: reportEditPlanModule,
    reportDDS: reportDDSModule,
    reportFoodCost: reportFoodCostModule,
    motivation: motivationModule,
    reportProductOrders: reportProductOrdersModule,
    reportByProducts: reportByProductsModule,
    reportFoodWorkers: reportFoodWorkersModule,
    reportWriteOff: reportWriteOffModule,
    reportByDays: reportByDaysModule,
    reportReservation: reportReservation,
    reportByHours: reportByHoursModule,
    reportStopLists: reportStopListsModule,
    reportTableUpdates: reportTableUpdatesModule,
    reportGameProgress: reportGameProgressModule,
    reportFillingAverageCheck: reportFillingAverageCheckModule,
    reportNonIntegratedOrders: reportNonIntegratedOrdersModule,
    reportOrderHelpers: reportOrderHelpersModule,
    reportGuestWaitTime: reportGuestWaitTimeModule,
    reportCouncil: reportCouncilModule,
    reportCooking: reportCookingModule,
    reportDetailedChecks: reportDetailedChecksModule,
    reportWaiterFfficiency: reportWaiterFfficiencyModule,
    reportTopProducts: reportTopProductsModule,
    reportVacancies: reportVacanciesModule,
    reportSummaryInvoices: reportSummaryInvoicesModule,
    reportWorkload: reportWorkloadModule,
    reportInvestments: reportInvestmentsModule,
    reportAverageTimeOfFronts: reportAverageTimeOfFrontsModule,
    reportTatar: reportTatarModule,
    reportPlanSales: reportPlanSalesModule,
    reportCounteragents: reportCounteragentsModule,
    reportSprint: reportSprintModule,
    motivationTatar: motivationTatarModule,
    reportWollzy: reportWollzyModule,
    reportBalanceSheet: reportBalanceSheetModule,
    reportProductionAnalitycs: reportProductionAnalitycsModule,
    reportMotivationCheeseria: reportMotivationCheeseriaModule,
    reportMotivationPayroll: reportMotivationPayrollModule,
    reportSalesArea: reportSalesAreaModule
};
